import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';

const windowSize = {
    MIN_HEIGHT: 320,
    MAX_HEIGHT: 768
}
export abstract class FormDialogControl {
    /**
     * Control type for user input
     */
    type: string;
    /**
     * FormGroup FormControl name
     */
    name: string;
    /**
     * Label for control
     */
    title: string;
}

export class ComboboxControl extends FormDialogControl {

}


interface IFormDialog {
    editForm: FormGroup;
    title: string;
    tabs: any[];
}

export class FormDialogTemplate extends BehaviorSubject<any> implements IFormDialog {
    /**
     * Fixed height (number) for dialog
     */
    private height: number;
    /**
     * Set to true when adding/creating, false for editing/updating
     */
    isNew: boolean;
    /**
     * Reactive form containing each form control
     */
    editForm: FormGroup;
    /**
     * Dialog title
     */
    title: any;
    tabs: any[] = [];
    inline: boolean;
    largeForm: boolean;
    isShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    selectedTab: number;
    /**
     * Text for Submit button
     */
    submitText: string;
    /**
     * Text for Cancel button
     */
    cancelText: string;
    /**
     * 
     */
    footerLabel: any = {};
    /**
     * 
     */
    notificationLabel: any = {};
    /**
     * 
     */
    save: any;
    /**
     * 
     */
    cancel: any;
    /**
     * 
     */
    controls: any;

    constructor() {
        super(null);
        this.editForm = new FormGroup({});
        this.subscribe(x => {
            this.isShow.next(x);
            if (x) {
                this.editForm.reset(x);
            } else {
                this.selectTab(0);
            }
        });

        this.controls = {
            cancel: true,
            save: true,
            submit: false
        }
    }


    initilize(
        title: any,
        editForm: FormGroup = null,
        controls: any[] = [],
    ) {
        this.title = title;
        this.editForm = editForm;
        this.tabs = controls;
        this.submitText = 'Save';
        this.cancelText = 'Cancel';
    }

    setHeight = (y: number) => {
        this.height = y < windowSize.MIN_HEIGHT ?
            windowSize.MIN_HEIGHT :
            y > windowSize.MAX_HEIGHT ?
                windowSize.MAX_HEIGHT : y;
    }

    getHeight = () => this.height;

    getFormClass = (): string => {
        return this.largeForm ? 'dialog-lg' : 'dialog-sm';
    }

    getFormControlClass = (control): string => {
        let formClass = '';
        if (control.stretch) formClass += 'stretch ';
        if (!control.stretch && this.largeForm) formClass += 'flex-column ';
        if (control.type !== 'radiogroup') formClass += this.inline ? 'k-form-inline' : 'k-form';
        return formClass;
    }

    show = () => {
        this.isShow.next(true);
    }

    hide = () => {
        this.isShow.next(false);
    }

    selectTab = (index: number) => {
        this.selectedTab = index;
        this.tabs.forEach((x, i) => i == index ? x.selected = true : x.selected = false);
    }

    submit = (dataItem: any = this.editForm.value, isNew: boolean = this.isNew): void => null;


}
